export interface StoryCharacter {
  name: string;
  role: string;
  avatar: any;
  ethnicity: string;
  description: string;
}

export interface StoryCharacters {
  [storyId: string]: StoryCharacter[];
}

export const STORY_CHARACTERS: StoryCharacters = {
  egocrisis: [
    {
      name: "Nina",
      role: "Cloud Engineer",
      avatar: require("../../assets/images/characters/egocrisis_nina.jpg"),
      ethnicity: "european",
      description: "Consultante Azure fraichement arrivee dans le studio, Nina doit securiser les acces avant que tout ne s effondre.",
    },
    {
      name: "Raoul",
      role: "CloudOps Lead",
      avatar: require("../../assets/images/characters/egocrisis_raoul.jpg"),
      ethnicity: "european",
      description: "Chef Ops cynique mais brillant. Il connait chaque faille du systeme.",
    },
    {
      name: "Youssef",
      role: "Security Architect",
      avatar: require("../../assets/images/characters/egocrisis_youssef.jpg"),
      ethnicity: "arabic",
      description: "Architecte securite obsede par les zero-trust policies. Sa paranoia est souvent justifiee.",
    },
    {
      name: "Anna",
      role: "Product Owner",
      avatar: require("../../assets/images/characters/egocrisis_anna.jpg"),
      ethnicity: "european",
      description: "Stakeholder exigeante qui ne comprend pas pourquoi la migration prend autant de temps.",
    },
    {
      name: "Emilie",
      role: "DevOps Engineer",
      avatar: require("../../assets/images/characters/egocrisis_emilie.jpg"),
      ethnicity: "european",
      description: "Ingenieure DevOps perfectionniste, auteure des pipelines CI/CD critiques.",
    },
    {
      name: "Darius",
      role: "Incident Manager",
      avatar: require("../../assets/images/characters/egocrisis_darius_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Manager d incident imperturbable. Quand Darius arrive, c est que la situation est grave.",
    },
  ],
  foundation_gamble: [
    {
      name: "Samir",
      role: "CEO",
      avatar: require("../../assets/images/characters/foundation_gamble_samir_man_40s.jpg"),
      ethnicity: "arabic_man",
      description: "PDG visionnaire qui vient d annoncer une migration Azure complete en 6 mois. Risque calcule... ou pas.",
    },
    {
      name: "Tarek",
      role: "CTO",
      avatar: require("../../assets/images/characters/foundation_gamble_tarek_man_40s.jpg"),
      ethnicity: "arabic_man",
      description: "Directeur Technique qui sait que l architecture actuelle est un chateau de cartes. Il doit tenir.",
    },
    {
      name: "Lucas",
      role: "Cloud Architect",
      avatar: require("../../assets/images/characters/foundation_gamble_lucas_man_30s.jpg"),
      ethnicity: "european_man",
      description: "Architecte Cloud charge de concevoir la nouvelle infrastructure. Chaque decision peut tout faire basculer.",
    },
    {
      name: "Kwame",
      role: "CSO - Chief Security Officer",
      avatar: require("../../assets/images/characters/foundation_gamble_kwame_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Responsable Securite qui surveille chaque composant. La compliance est sa religion.",
    },
    {
      name: "James",
      role: "Finance Director",
      avatar: require("../../assets/images/characters/foundation_gamble_james_man_30s.jpg"),
      ethnicity: "white_man",
      description: "Directeur financier qui regarde les budgets cloud avec un oeil suspicieux. Chaque euro compte.",
    },
  ],
  architecture_under_fire: [
    {
      name: "Mina Brown",
      role: "CTO",
      avatar: require("../../assets/images/characters/architecture_under_fire_Mina_Brown.jpg"),
      ethnicity: "european",
      description: "CTO exigeante qui impose un mode operatoire defendable avant la fenetre de cablage.",
    },
    {
      name: "Karim Belkacem",
      role: "Cloud Architect",
      avatar: require("../../assets/images/characters/architecture_under_fire_Hugo_Petit.jpg"),
      ethnicity: "european",
      description: "Cloud Architect charge de documenter et poser la couche VPN hybride sous pression.",
    },
    {
      name: "Samir Idrissi",
      role: "Network Engineer",
      avatar: require("../../assets/images/characters/architecture_under_fire_Samir_Idrissi.jpg"),
      ethnicity: "arabic",
      description: "Ingenieur reseau on-prem qui depend de la preparation Azure pour cabler le tunnel S2S.",
    },
    {
      name: "Diane Leclerc",
      role: "Auditor",
      avatar: require("../../assets/images/characters/architecture_under_fire_Diane_Leclerc.jpg"),
      ethnicity: "european",
      description: "Auditrice qui challenge chaque hypothese d architecture et exige des roles clairement definis.",
    },
  ],
  data_storm: [
    {
      name: "Aisha",
      role: "Data Engineer Lead",
      avatar: require("../../assets/images/characters/data_storm_aisha_woman_30s.jpg"),
      ethnicity: "african_asian_woman",
      description: "Lead Data Engineer qui doit maitriser 42 millions de transactions par jour. La tempete de donnees n attend pas.",
    },
    {
      name: "Marcus",
      role: "Data Scientist",
      avatar: require("../../assets/images/characters/data_storm_marcus_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Scientifique des donnees dont les modeles ML tournent en prod. Une anomalie et tout s effondre.",
    },
    {
      name: "Darius",
      role: "CTO Analytics",
      avatar: require("../../assets/images/characters/data_storm_darius_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Directeur Tech Analytics sous pression extreme. Les rapports du board arrivent dans 48h.",
    },
    {
      name: "Jun",
      role: "Data Analyst",
      avatar: require("../../assets/images/characters/data_storm_jun_woman_30s.jpg"),
      ethnicity: "east_asian_woman",
      description: "Analyste precise et methodique. Elle trouve les patterns que les autres ratent.",
    },
    {
      name: "Soo-Min",
      role: "BI Engineer",
      avatar: require("../../assets/images/characters/data_storm_soo-min_woman_30s.jpg"),
      ethnicity: "east_asian_woman",
      description: "Ingenieure BI qui maintient les dashboards critiques. Ses alertes sont la premiere ligne de defense.",
    },
  ],
  cloud_heist: [
    {
      name: "Keiko",
      role: "Ethical Hacker",
      avatar: require("../../assets/images/characters/cloud_heist_keiko_woman_30s.jpg"),
      ethnicity: "african_asian_woman",
      description: "Hackeuse ethique mandatee pour penetrer les defenses AWS avant les vrais attaquants.",
    },
    {
      name: "Nabil",
      role: "CISO",
      avatar: require("../../assets/images/characters/cloud_heist_nabil_man_40s.jpg"),
      ethnicity: "arabic_man",
      description: "Responsable Securite Information qui surveille chaque mouvement. Il ne fait confiance a personne.",
    },
    {
      name: "Leila",
      role: "DevOps Lead",
      avatar: require("../../assets/images/characters/cloud_heist_leila_woman_30s.jpg"),
      ethnicity: "arabic_woman",
      description: "Lead DevOps qui maintient les pipelines AWS en vie. Son acces privilegies en font une cible.",
    },
    {
      name: "Yasmine",
      role: "Cloud Security Analyst",
      avatar: require("../../assets/images/characters/cloud_heist_yasmine_woman_30s.jpg"),
      ethnicity: "arabic_woman",
      description: "Analyste securite cloud qui surveille les logs CloudTrail. Chaque evenement suspect est signale.",
    },
  ],
  quantum_gambit: [
    {
      name: "Dr. Yuki Tanaka",
      role: "Quantum Researcher",
      avatar: require("../../assets/images/characters/data_storm_jun_woman_30s.jpg"),
      ethnicity: "east_asian_woman",
      description: "Chercheuse en informatique quantique qui a fait tourner l algorithme de Shor avec succes. Sa decouverte menace toute la cryptographie actuelle.",
    },
    {
      name: "Marcus Wright",
      role: "CISO",
      avatar: require("../../assets/images/characters/data_storm_marcus_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Responsable Securite qui comprend l ampleur de la menace quantique. Il a 6 mois pour migrer toute l infrastructure cryptographique.",
    },
  ],
  neural_override: [
    {
      name: "Karim",
      role: "AI Lead",
      avatar: require("../../assets/images/characters/neural_override_karim_man_40s.jpg"),
      ethnicity: "arabic_man",
      description: "Responsable IA qui supervise les modeles de deep learning en production. Quand l IA derive, il intervient.",
    },
    {
      name: "Fatima",
      role: "ML Engineer",
      avatar: require("../../assets/images/characters/neural_override_fatima_woman_30s.jpg"),
      ethnicity: "arabic_woman",
      description: "Ingenieure Machine Learning dont les modeles menacent de surpasser leurs concepteurs.",
    },
    {
      name: "Amira",
      role: "Product Owner AI",
      avatar: require("../../assets/images/characters/neural_override_amira_woman_30s.jpg"),
      ethnicity: "arabic_woman",
      description: "Product Owner qui pousse pour deployer plus vite. La pression business contre l ethique.",
    },
    {
      name: "Erik",
      role: "AI Ethics Officer",
      avatar: require("../../assets/images/characters/neural_override_erik_man_30s.jpg"),
      ethnicity: "european_man",
      description: "Officier Ethique IA qui s assure que les algorithmes restent sous controle humain.",
    },
  ],
  pipeline_inferno: [
    {
      name: "Viktor",
      role: "DevOps Manager",
      avatar: require("../../assets/images/characters/pipeline_inferno_viktor_man_30s.jpg"),
      ethnicity: "european_or_asiatic",
      description: "Manager DevOps qui supervise les pipelines critiques. Quand le pipeline brule, c est lui qui etouffe les flammes.",
    },
    {
      name: "Liwei",
      role: "SRE Lead",
      avatar: require("../../assets/images/characters/pipeline_inferno_liwei_woman_30s.jpg"),
      ethnicity: "east_asian_woman",
      description: "Site Reliability Engineer dont l objectif est 99.99% uptime. Les incidents sont sa hantise.",
    },
    {
      name: "Priya",
      role: "Senior Developer",
      avatar: require("../../assets/images/characters/pipeline_inferno_priya_woman_30s.jpg"),
      ethnicity: "african_asian_woman",
      description: "Developpeuse senior dont le code a declenche l incident. Elle doit reparer avant le deploiement prod.",
    },
    {
      name: "Katya",
      role: "QA Lead",
      avatar: require("../../assets/images/characters/pipeline_inferno_katya_woman_20s.jpg"),
      ethnicity: "russian_woman",
      description: "Lead QA inflexible. Aucun bug ne passe sa revue. Ou presque.",
    },
  ],
  merge_conflict: [
    {
      name: "Priya",
      role: "Tech Lead",
      avatar: require("../../assets/images/characters/merge_conflict_priya_woman_30s.jpg"),
      ethnicity: "african_asian_woman",
      description: "Tech Lead coincee entre deux equipes dont les branches Git divergent depuis 3 mois.",
    },
    {
      name: "Marcus",
      role: "Backend Engineer",
      avatar: require("../../assets/images/characters/merge_conflict_marcus_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Ingenieur backend entete qui refuse de rebase sa branche. Le merge conflict est personnel.",
    },
    {
      name: "Viktor",
      role: "Frontend Architect",
      avatar: require("../../assets/images/characters/merge_conflict_viktor_man_30s.jpg"),
      ethnicity: "european_or_asiatic",
      description: "Architecte frontend dont les composants React creent des conflits en cascade.",
    },
    {
      name: "Olga",
      role: "Engineering Manager",
      avatar: require("../../assets/images/characters/merge_conflict_olga_woman_40s.jpg"),
      ethnicity: "russian_woman",
      description: "Manager d ingenierie qui doit resoudre le conflit humain avant de resoudre le conflit Git.",
    },
  ],
  deadline_paradox: [
    {
      name: "Sakura",
      role: "Project Manager",
      avatar: require("../../assets/images/characters/deadline_paradox_sakura_woman_30s.jpg"),
      ethnicity: "asian_woman",
      description: "Chef de projet dont la deadline est impossible. 3 semaines de travail, 5 jours restants.",
    },
    {
      name: "Kwame",
      role: "Lead Developer",
      avatar: require("../../assets/images/characters/deadline_paradox_kwame_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Developpeur lead qui connait le vrai cout technique de chaque raccourci.",
    },
    {
      name: "Nyah",
      role: "UX Designer",
      avatar: require("../../assets/images/characters/deadline_paradox_nyah_woman_30s.jpg"),
      ethnicity: "black_woman",
      description: "Designer UX dont les maquettes sont parfaites mais jamais finalisees a temps.",
    },
    {
      name: "Kenji",
      role: "QA Engineer",
      avatar: require("../../assets/images/characters/deadline_paradox_kenji_man_30s.jpg"),
      ethnicity: "asiatic_man",
      description: "Ingenieur QA qui sait qu on va lui demander de sauter les tests. Il refuse.",
    },
  ],
  arabic_modern: [
    {
      name: "Tarek",
      role: "Language Director",
      avatar: require("../../assets/images/characters/arabic_modern_tarek_man_40s.jpg"),
      ethnicity: "arabic_man",
      description: "Directeur du programme d arabe moderne standard. Gardien de la langue dans un monde qui change.",
    },
    {
      name: "Leila",
      role: "Cultural Linguist",
      avatar: require("../../assets/images/characters/arabic_modern_leila_woman_30s.jpg"),
      ethnicity: "arabic_woman",
      description: "Linguiste culturelle qui navigue entre dialectes et langue formelle dans les affaires internationales.",
    },
    {
      name: "Natasha",
      role: "International Business Consultant",
      avatar: require("../../assets/images/characters/arabic_modern_natasha_woman_40s.jpg"),
      ethnicity: "russian_woman",
      description: "Consultante internationale qui apprend l arabe pour negocier dans la region MENA.",
    },
    {
      name: "Viktor",
      role: "Diplomatic Interpreter",
      avatar: require("../../assets/images/characters/arabic_modern_viktor_man_30s.jpg"),
      ethnicity: "european_or_asiatic",
      description: "Interprete diplomatique dont la precision linguistique peut changer le cours d une negociation.",
    },
  ],
  learning_machine: [
    {
      name: "Zara Chen",
      role: "ML Engineer",
      avatar: require("../../assets/images/characters/data_storm_jun_woman_30s.jpg"),
      ethnicity: "east_asian_woman",
      description: "Ingenieure Machine Learning qui a concu l algorithme trop efficace. Elle doit comprendre pourquoi avant que les regulateurs n interviennent.",
    },
    {
      name: "Marcus Davis",
      role: "Data Scientist",
      avatar: require("../../assets/images/characters/data_storm_marcus_man_30s.jpg"),
      ethnicity: "black_man",
      description: "Scientifique des donnees dont les courbes d apprentissage cachent un data leakage critique. Sa reputation est en jeu.",
    },
    {
      name: "Priya Sharma",
      role: "Product Manager",
      avatar: require("../../assets/images/characters/pipeline_inferno_priya_woman_30s.jpg"),
      ethnicity: "african_asian_woman",
      description: "Product Manager sous pression des investisseurs. Elle veut deployer. L equipe technique veut freiner. Un seul peut avoir raison.",
    },
  ],
  ink_protocol: [
    {
      name: "Prof. Viktor Novak",
      role: "Professor",
      avatar: require("../../assets/images/characters/merge_conflict_viktor_man_30s.jpg"),
      ethnicity: "european_or_asiatic",
      description: "Professeur dont l integrite academique est mise en cause. Il doit prouver que sa recherche est originale avant que le comite ne statue.",
    },
    {
      name: "Dr. Olga Smirnova",
      role: "Editor",
      avatar: require("../../assets/images/characters/merge_conflict_olga_woman_40s.jpg"),
      ethnicity: "russian_woman",
      description: "Editrice de revue scientifique qui a recu la plainte de plagiat. Elle veut la verite, pas un scandale.",
    },
    {
      name: "Kenji Tanaka",
      role: "PhD Student",
      avatar: require("../../assets/images/characters/deadline_paradox_kenji_man_30s.jpg"),
      ethnicity: "asiatic_man",
      description: "Doctorant dont la these a ete copiee — ou est-ce l inverse ? La frontiere entre influence et plagiat est plus floue qu il ne pensait.",
    },
  ],
};

export const ALL_CHARACTERS: StoryCharacter[] = Object.values(STORY_CHARACTERS).flat();

export const getCharactersForStory = (storyKey: string): StoryCharacter[] => {
  return STORY_CHARACTERS[storyKey] ?? [];
};

function normalizeCharToken(value: string): string {
  return value.toLowerCase().replace(/[\s_-]+/g, '');
}

/** Resolve a bundled avatar image for a character within a story. */
export function resolveStoryCharacterAvatar(
  storyKey: string,
  lookup: { id?: string; name?: string },
): any | undefined {
  const chars = STORY_CHARACTERS[storyKey] ?? [];
  if (!chars.length) return undefined;

  if (lookup.name) {
    const exact = chars.find(c => c.name === lookup.name);
    if (exact) return exact.avatar;

    const normName = normalizeCharToken(lookup.name);
    const byNorm = chars.find(c => normalizeCharToken(c.name) === normName);
    if (byNorm) return byNorm.avatar;

    const first = lookup.name.split(/\s+/)[0]?.toLowerCase();
    if (first) {
      const byFirst = chars.find(c => c.name.split(/\s+/)[0]?.toLowerCase() === first);
      if (byFirst) return byFirst.avatar;
    }
  }

  if (lookup.id) {
    const normId = normalizeCharToken(lookup.id);
    const byId = chars.find(c => {
      const normChar = normalizeCharToken(c.name);
      return normChar === normId || normChar.includes(normId) || normId.includes(normChar);
    });
    if (byId) return byId.avatar;
  }

  return undefined;
}
